import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io } from 'socket.io-client';
import { Socket } from 'ngx-socket-io';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ChatService {

  public socketStatus = false;

  constructor(private socket: Socket) {
    this.checkStatus();
  }


  joinRoom(data:any): void {
    this.socket.emit('joinRoom', data);
  }

  // leaveRoom(data:any): void {
  //   this.socket.emit('joinRoom', data);
  // }

  sendMessage(msg: string) {
     if(msg) {
        this.socket.emit('chatMessage', msg);
     }
  }

  getMessage() {
     return this.socket.fromEvent('message').pipe(map((data:any) => data));
  }

  getMessageHistory(data) {
    this.socket.emit('get-messages-history', data);
  }

  outputMessage() {
    return this.socket.fromEvent('output-messages').pipe(map((data:any) => data));
  }

  checkStatus() {
    this.socket.on("connect", () => {
      this.socketStatus = true;
    });
    this.socket.on("disconnect", ([...args]) => {
      this.socketStatus = false;
    });
  }


}
